import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import CardMedia from "@mui/material/CardMedia";
import { pink, red, blue, blueGrey } from "@mui/material/colors";
import mnesimg from "../Images/logo_mnes.jpg";
import laimeimg from "../Images/logo_white.png";
import Card from "@mui/material/Card";
import { Avatar, CardActionArea, Container } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import { createSvgIcon } from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import { MstaFontFamily } from "../Functions/Style/MstaFont";
import {
  XIcon,
  InstagramIcon,
  FacebookIcon,
  YoutubeIcon,
} from "../Functions/Style/Icon";
import { useWindowDimensions } from "../Functions/ScreenOperation/useWindowDimension";
import mnist from "../Images/MNiST.png";

function Copyright() {
  return (
    <Grid item display={"gap"} gap={2} py={2} sx={{ mt: { md: 8 } }}>
      <Typography variant="body2" color="text.secondary" align="left" fontFamily={MstaFontFamily}>
        <Link
          color="inherit"
          target="_blank"
          href="https://sites.google.com/mnes.org/msta-support/%E3%83%9B%E3%83%BC%E3%83%A0/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC"
        >
          プライバシーポリシー
        </Link>{" "}
        <Link
          color="inherit"
          target="_blank"
          href="https://sites.google.com/mnes.org/msta-support/%E3%83%9B%E3%83%BC%E3%83%A0/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"
        >
          規約
        </Link>{" "}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="left" fontFamily={MstaFontFamily}>
        {"Copyright © "}
        <Link
          color="inherit"
          target="_blank"
          href="https://sites.google.com/mnes.org/mnist-official/home"
        >
          MNiST
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Grid>
  );
}

// export function Footer() {
//     const accent = lightBlue[100];
//     const { width } = useWindowDimensions();
//     return (
//         <div style={{ zIndex: 10 }}>
//             <Box
//                 gap={2}
//                 sx={{
//                     p: 2,
//                     bgcolor: accent,
//                     gap: 5,
//                 }}
//             >
//                 <Grid container spacing={2}>
//                     <Grid item xs={3}>
//                         <Card sx={{ minHeight: 90, display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
//                             <CardActionArea>
//                                 <a rel="noreferrer"
//                                     href="https://mnes.life/"
//                                     target="_blank">
//                                     <img src={mnesimg}
//                                         alt='MNES Logo'
//                                         width={width > 450 ? width * 0.15 : width * 0.2}
//                                         height={width > 450 ? 85 : 25} />
//                                 </a>
//                             </CardActionArea>
//                         </Card>
//                     </Grid>
//                     <Grid item xs={3} sx={{ zIndex: 0 }}>
//                         <Card sx={{ zIndex: 1, minHeight: 90, display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
//                             <CardActionArea
//                                 sx={{ alignContent: 'center', justifyContent: 'center' }}>
//                                 <a rel="noreferrer"
//                                     href="https://laime-ml.github.io/?fbclid=IwAR2ETxkW4ZUq9oRqd7Mn04ffzviU7GYSrS3Ho3SzAsgkB5wmxdrhR8QzLi4"
//                                     target="_blank">
//                                     <img src={laimeimg}
//                                         alt='LAIME Logo'
//                                         width={width > 450 ? width * 0.23 : width * 0.2}
//                                         height={width > 450 ? 85 : 25} />
//                                     {/*<CardMedia
//                                         component="img"
//                                         height={90}
//                                         sx={{ width: width * 0.1 }}
//                                         image={laimeimg}
//                                         alt="green iguana" />

//                                             <CardMedia
//                                             component="img"
//                                             height="80"

//                                             image={laimeimg}
//                                             alt="green iguana"
//                                         />

//                                         */}

//                                 </a>
//                             </CardActionArea>
//                         </Card>
//                     </Grid>
//                     <Grid display={'flex'} justifyContent={'end'} alignItems={'center'} gap={1} xs={6}>

//                         <a rel="noreferrer"
//                             href="https://www.instagram.com/mnist_official/"
//                             target="_blank">
//                             <InstagramIcon sx={{ fontSize: { md: 50, xs: 30 } }} />
//                         </a>

//                         <a rel="noreferrer"
//                             href="https://www.facebook.com/mnist2020/"
//                             target="_blank">
//                             <FacebookIcon sx={{ fontSize: { md: 50, xs: 30 } }} />
//                         </a>

//                         <a rel="noreferrer"
//                             href="https://twitter.com/mnist_official"
//                             target="_blank">
//                             <XIcon sx={{ fontSize: { md: 45, xs: 30 }, color: 'black' }} />
//                         </a>
//                         <a rel="noreferrer"
//                             href="https://www.youtube.com/channel/UCb4-B_99_Om1megYVYyNqbA/featured"
//                             target="_blank">
//                             <YoutubeIcon sx={{ fontSize: { md: 70, xs: 40 } }} />
//                         </a>
//                     </Grid>
//                 </Grid>
//                 <Copyright />
//             </Box>
//         </div >
//     );
// }

export function Footer() {
  const accent = "#0186D9";
  const bgcolor = lightBlue[50];
  const contents = ["ホーム", "正常画像", "症例検索", "疾患一覧", "問題演習", "CT・MRI入門", "マイページ","使い方"];

  const navigate = useNavigate();

  const handleOpenLink = (element: string) => {
    let position = 0;
    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
    if (element === "ホーム") {
      navigate("/");
    } else if (element === "正常画像") {
      navigate("/basic");
    } else if (element === "症例検索") {
      navigate("/catalogue/search");
    } else if (element === "疾患一覧") {
      navigate("/catalogue/disease");
    } else if (element === "CT・MRI入門") {
      window.open(
        "https://sites.google.com/mnes.org/msta-tutorial/%E3%83%9B%E3%83%BC%E3%83%A0",
        "_blank"
      );
    } else if (element === "問題演習") {
      navigate("/mstudy");
    } else if (element === "マイページ") {
      navigate("/mypage/account");
    } else if (element === "使い方") {
      window.open(
        "https://sites.google.com/mnes.org/msta-support/%E3%83%9B%E3%83%BC%E3%83%A0/msta%E3%81%AE%E4%BD%BF%E3%81%84%E6%96%B9",
        "_blank"
      );
    }
  };

  return (
    <div style={{ zIndex: 10 }}>
      <Box sx={{ px: 2, pt: 6, pb: 8, bgcolor: bgcolor }}>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
                mr={{ base: "none", md: 8 }}
              >
                <Box
                  component="a"
                  href="https://sites.google.com/mnes.org/mnist-official/home"
                  target="_blank"
                  rel="noopener noreferrer"
                  display="flex"
                  alignItems="center"
                  sx={{ textDecoration: "none", color: "inherit" }}
                >
                  <Avatar
                    alt="MNiST Logo"
                    sx={{
                      width: 45,
                      height: 45,
                      bgcolor: "white",
                      marginRight: 1,
                    }}
                  >
                    <img src={mnist} alt="MNiST Logo" width="42" height="42" />
                  </Avatar>
                  <Typography
                    fontWeight="bold"
                    color={accent}
                    variant="h6"
                    textAlign="left"
                    fontFamily={MstaFontFamily}
                  >
                    学生団体MNiST
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ mt: 3 }}
                  textAlign="justify"
                  fontFamily={MstaFontFamily}
                >
                  私たちMNiSTは株式会社MNESご支援のもと、「学生の目線から医療を、そして世界をより良いものにしたい」をモットーに活動しています。
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    gap={1}
                  >
                    <Typography
                      fontWeight="bold"
                      color={accent}
                      variant="subtitle1"
                      textAlign="left"
                      fontFamily={MstaFontFamily}
                    >
                      Contents
                    </Typography>
                    {contents.map((content) => (
                      <Typography
                        key={content}
                        onClick={() => handleOpenLink(content)}
                        sx={{
                          display: "block",
                          color: "black",
                          mt: 1,
                          textAlign: "left",
                          cursor: "pointer",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                        fontFamily={MstaFontFamily}
                      >
                        {content}
                      </Typography>
                    ))}
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    gap={1}
                  >
                    <Typography
                      fontWeight="bold"
                      color={accent}
                      variant="subtitle1"
                      textAlign="left"
                      fontFamily={MstaFontFamily}
                    >
                      Supported by
                    </Typography>
                    <Link
                      href="https://mnes.life/"
                      target="_blank"
                      underline="none"
                      sx={{
                        display: "block",
                        color: "black",
                        mt: 1,
                        textAlign: "left",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                      fontFamily={MstaFontFamily}
                    >
                      MNES
                    </Link>
                    <Typography
                      fontWeight="bold"
                      color={accent}
                      variant="subtitle1"
                      sx={{ mt: 3 }}
                      textAlign="left"
                      fontFamily={MstaFontFamily}
                    >
                      Collaborate with
                    </Typography>
                    <Link
                      href="https://laime-ml.github.io/?fbclid=IwAR2ETxkW4ZUq9oRqd7Mn04ffzviU7GYSrS3Ho3SzAsgkB5wmxdrhR8QzLi4"
                      target="_blank"
                      underline="none"
                      sx={{
                        display: "block",
                        color: "black",
                        mt: 1,
                        textAlign: "left",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                      fontFamily={MstaFontFamily}
                    >
                      LAIME
                    </Link>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    fontWeight="bold"
                    color={accent}
                    variant="subtitle1"
                    textAlign="left"
                    fontFamily={MstaFontFamily}
                  >
                    Follow
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <a
                      rel="noreferrer"
                      href="https://www.facebook.com/mnist2020/"
                      target="_blank"
                    >
                      <FacebookIcon
                        sx={{ fontSize: { md: 40, xs: 30 }, marginRight: 1 }}
                      />
                    </a>
                    <a
                      rel="noreferrer"
                      href="https://www.instagram.com/mnist_official/"
                      target="_blank"
                    >
                      <InstagramIcon
                        sx={{ fontSize: { md: 40, xs: 30 }, marginRight: 1 }}
                      />
                    </a>
                    <a
                      rel="noreferrer"
                      href="https://twitter.com/mnist_official"
                      target="_blank"
                    >
                      <XIcon
                        sx={{
                          fontSize: { md: 35, xs: 30 },
                          color: "black",
                          marginRight: 1,
                        }}
                      />
                    </a>
                    <a
                      rel="noreferrer"
                      href="https://www.youtube.com/channel/UCb4-B_99_Om1megYVYyNqbA/featured"
                      target="_blank"
                    >
                      <YoutubeIcon sx={{ fontSize: { md: 60, xs: 40 } }} />
                    </a>
                  </Box>
                  <Copyright />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
}
